import React from "react";
import { PeekBox, PeekTooltip, useTheme } from "@piiqtechnologies/ui-components";
import { focusRingSx } from "./whiskerChartUtils";
import { WhiskerMinMaxLabel } from "./WhiskerMinMaxLabel";
export const WhiskerEndLabel = ({ value, caption, tooltipTitle }) => {
    const theme = useTheme();
    return (React.createElement(PeekTooltip, { title: tooltipTitle, placement: "top" },
        React.createElement(PeekBox, { tabIndex: 0, sx: focusRingSx(theme) },
            React.createElement(WhiskerMinMaxLabel, { value: value, caption: caption }))));
};
export default WhiskerEndLabel;
